import { html, css, LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

@customElement('footer-component')
export class FooterComponent extends LitElement {
  static styles = css`
    .text-color {
      color: var(--lh-color-neutral-white, #ffffff);
    }
  `
  render() {
    return html`
      <!-- Dark theme -->
      <lh-footer
        theme="dark"
        fine-print-src="https://config-cdn.bcbsnc.com/footer/bcbsnc/fine-print.json"
      >
        <lh-logo slot="logo" name="bcbsnc-full" inverse></lh-logo>
        <div slot="disclosures">
          <p>
            <strong>Attention:</strong> This website is operated by Blue Cross
            and Blue Shield of North Carolina and is not the Health Insurance
            Marketplace® website at
            <a class="text-color" href="https://HealthCare.gov" target="_blank"
              >HealthCare.gov</a
            >. This website does not display all Qualified Health Plans (QHPs)
            available through
            <a class="text-color" href="https://HealthCare.gov" target="_blank"
              >HealthCare.gov</a
            >. To see all available QHP options, go to the Health Insurance
            Marketplace® website at
            <a class="text-color" href="https://HealthCare.gov" target="_blank"
              >HealthCare.gov</a
            >.
          </p>
          <p>
            Also, you should visit the Health Insurance Marketplace® website at
            <a class="text-color" href="https://HealthCare.gov" target="_blank"
              >HealthCare.gov</a
            >
            if:
          </p>
          <ol>
            <li>You want to select a catastrophic health plan.</li>
            <li>
              You want to enroll members of your household in dental coverage.
            </li>
          </ol>
        </div>
      </lh-footer>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'footer-component': FooterComponent
  }
}
